import React from 'react'
import { FaArrowLeftLong } from "react-icons/fa6";
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { IoSearchOutline } from "react-icons/io5";
import { BsQrCodeScan } from "react-icons/bs";


const MerchantSiteHeader = () => {
  return (
    <Wrapper>
        <div className='container-fluid' style={{backgroundColor:"#ef4766",padding:" 10px 40px",fontSize:"20px",color:"#000"}}>
            <div className='container p-0'>
                <div className='row d-flex align-item-center p-0'>
                    <div className='col-2 text-start d-flex align-item-center px-1' style={{fontSize:'1.3rem'}}>
                        <NavLink to={'/'} style={{color:"#000"}}><FaArrowLeftLong /></NavLink>
                    </div>
                    <div className='col-10 p-0 px-1'>
                        <form className="d-flex align-items-center">
                            <button
                            type="submit"
                            className="d-flex justify-content-center align-items-center bg-none border-1 border-end-0 rounded-start-1 py-1"
                            style={{ backgroundColor: "#fff", width: "40px", height: "40px" }}
                            >
                            <IoSearchOutline />
                            </button>
                            <input
                            placeholder="Search All Brand"
                            className="border-1 border-start-0 text-decoration-none rounded-end-1 ps-1 w-100 pe-2"
                            style={{ outline: "none", height: "40px" }}
                            type='search'
                            />
                        </form>
                    </div>                    
                </div>
            </div>
        </div>
        
    </Wrapper>
  )
}

export default MerchantSiteHeader

const Wrapper = styled.section`
  position: sticky;
  top: 0;
  z-index: 5;
  background: white;
//   border-bottom: 0.25rem solid #ddd;
//   box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
`;